/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invites_TitleInputs */

const en_invites_title = /** @type {(inputs: Invites_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invites`)
};

const de_invites_title = /** @type {(inputs: Invites_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungen`)
};

/**
* | output |
* | --- |
* | "Invites" |
*
* @param {Invites_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const invites_title = /** @type {((inputs?: Invites_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invites_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_invites_title(inputs)
	return en_invites_title(inputs)
});